import { HttpClient, RouteGenerator } from "silver";
import { isMyonApiSuccess, MyonApiResponse } from "shared/Api/MyonApiResponse";

export interface ProjectSchema {
	id: number;
	title: string;
	archived: boolean;
	published: boolean;
}

export class BookProjectService {

	constructor(
		private httpClient: HttpClient,
		private router: RouteGenerator
	) { }

	public async createNewProjectWithBookIds(title: string, bookIds: number[]): Promise<ProjectSchema> {
		title = title.trim();
		if (title.trim() === "") {
			throw new Error("Invalid project title");
		}
		const body = { title, bookIds };
		const url = this.router.generate("api/projects", "withBooks", { }, "json");
		const response: MyonApiResponse<{ project: ProjectSchema }> = await this.httpClient.post(url, { body });

		if (! isMyonApiSuccess(response)) {
			console.error(response);
			throw new Error("Bad response");
		}

		return response.result.project;
	}

	public async addBookIdsToProject(projectId: number, bookIds: number[]): Promise<ProjectSchema> {
		const body = { projectId, bookIds };
		const url = this.router.generate("api/projects", "withBooks", { }, "json");
		const response: MyonApiResponse<{ project: ProjectSchema }> = await this.httpClient.patch(url, { body });

		if (! isMyonApiSuccess(response)) {
			console.error(response);
			throw new Error("Bad response");
		}

		return response.result.project;
	}

	public async getAllProjects(): Promise<ProjectSchema[]> {
		const url = this.router.generate("api/projects", null, { }, "json");
		const response: MyonApiResponse<{ projects: ProjectSchema[] }> = await this.httpClient.get(url);

		if (! isMyonApiSuccess(response)) {
			console.error(response);
			throw new Error("Bad response");
		}

		return response.result.projects;
	}

	public async getBookProjects(bookId: number): Promise<ProjectSchema[]> {
		const url = this.router.generate("api/projects", null, { bookId: String(bookId) }, "json");
		const response: MyonApiResponse<{ projects: ProjectSchema[] }> = await this.httpClient.get(url);

		if (! isMyonApiSuccess(response)) {
			console.error(response);
			throw new Error("Bad response");
		}

		return response.result.projects;
	}
}
